import { LanguageKey, LanguageSingleton } from '../../../shared-core/domain';

const LANGUAGES_WITH_TABS: LanguageKey[] = ['nl'];

export function showTabsForLanguage(): boolean {
  return LANGUAGES_WITH_TABS.includes(LanguageSingleton.get());
}
